const buildPropertyInfoObject = (queryData, queryData2, uData) => {
  const dataObject = {
    qdbapi: {
      udata: uData,
      apptoken: "dsgdzckckic6iabhuap3kdyiwdgc",
      QueryString: queryData,
      QueryString2: queryData2,
      fmt: "structured"
    }
  };

  //dataObject.qdbapi.query = `{'3'.EX.'1'}`;
  
  if(queryData && queryData2){
    dataObject.qdbapi.query = `{'257'.EX.'${queryData}'}AND{'258'.EX.'${queryData2}'}`;
  }
  
  return dataObject;
};

export default buildPropertyInfoObject;
